(() => {
  const cardSelector = '.template-collection sht-variant-swtch';
  const buttonSelector = '.js-variant-swatch-item';
  const activeByCard = new WeakMap();

  const preview = (button) => {
    const card = button.closest(cardSelector);
    if (!card || activeByCard.get(card) === button || button.classList.contains('btn-active')) return;

    activeByCard.set(card, button);
    button.click();
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const button = event.target.closest(`${cardSelector} ${buttonSelector}`);
    if (button) preview(button);
  });

  document.addEventListener('focusin', (event) => {
    const button = event.target.closest(`${cardSelector} ${buttonSelector}`);
    if (button) preview(button);
  });

  const productSwatchSelector = '.template-product .main-product sht-variant-radios .product-swatches__item';
  const previews = new WeakMap();

  const getProductPreview = (swatch) => {
    const picker = swatch.closest('sht-variant-radios');
    // Aero/Luna: show only the selected variant, never an unselected hover color.
    if (/\/(?:isaac-mizrahi-(?:aero|luna)-|luna-20-)/.test(picker?.dataset.url || '')) return null;
    const input = swatch.querySelector('.js-variant-radio-item');
    const gallery = swatch.closest('.main-product')?.querySelector('.product-slideshow__items');
    const firstImageTile = gallery?.querySelector('.product-slideshow__item--image');
    if (!picker || !input || !firstImageTile) return null;

    let variants;
    try {
      variants = JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent || '[]');
    } catch (error) {
      return null;
    }

    const groups = Array.from(picker.querySelectorAll('.js-variant-radio-container'));
    const group = input.closest('.js-variant-radio-container');
    const optionIndex = groups.indexOf(group);
    if (optionIndex < 0) return null;

    const selectedOptions = groups.map((container) => {
      return container.querySelector('.js-variant-radio-item:checked')?.value || '';
    });
    selectedOptions[optionIndex] = input.value;

    const variant = variants.find((candidate) => {
      return candidate.options?.every((value, index) => value === selectedOptions[index]);
    }) || variants.find((candidate) => candidate.options?.[optionIndex] === input.value);

    const source = variant?.featured_media?.preview_image?.src;
    if (!source) return null;

    let overlay = previews.get(firstImageTile);
    if (!overlay) {
      overlay = document.createElement('img');
      overlay.className = 'mirage-product-swatch-preview';
      overlay.setAttribute('aria-hidden', 'true');
      firstImageTile.appendChild(overlay);
      previews.set(firstImageTile, overlay);
    }

    return { overlay, source: source.startsWith('//') ? `https:${source}` : source, label: input.value };
  };

  const showProductPreview = (swatch) => {
    const previewData = getProductPreview(swatch);
    if (!previewData) return;
    const { overlay, source, label } = previewData;
    overlay.dataset.previewSource = source;
    overlay.alt = `${label} product preview`;
    overlay.onload = () => {
      if (overlay.dataset.previewSource === source) overlay.classList.add('is-active');
    };
    overlay.src = source;
    if (overlay.complete) overlay.classList.add('is-active');
  };

  const hideProductPreview = (swatch) => {
    const tile = swatch.closest('.main-product')?.querySelector('.product-slideshow__item--image');
    const overlay = tile && previews.get(tile);
    overlay?.classList.remove('is-active');
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const swatch = event.target.closest(productSwatchSelector);
    if (swatch && !swatch.contains(event.relatedTarget)) showProductPreview(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const swatch = event.target.closest(productSwatchSelector);
    if (swatch && !swatch.contains(event.relatedTarget)) hideProductPreview(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(productSwatchSelector);
    if (swatch) showProductPreview(swatch);
  });

  document.addEventListener('focusout', (event) => {
    const swatch = event.target.closest(productSwatchSelector);
    if (swatch && !swatch.contains(event.relatedTarget)) hideProductPreview(swatch);
  });
})();
